import React, { useEffect, useState } from "react";
import {
  AddButton,
  CancelButton,
  SaveButton,
  UpdateButton,
} from "../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  addPermission,
  getAlldepartments,
  getallPermissions,
  getAllUimodules,
} from "../../redux/features/permissionSlice";

const AddPermission = ({ dispatchparams }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, departments, uimodules } = useSelector(
    (state) => state.permission
  );

  const ValidationSchema = Yup.object().shape({
    description: Yup.string().required("Please add description"),
    path: Yup.string().required("Add a path"),
    title: Yup.string().required("Add a title"),
    module: Yup.number().required("Select module"),
    menuItem: Yup.number().required("Select Menu Item"),
    department_id: Yup.string().required("Select a department"),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      description: "",
      path: "",
      title: "",
      module: "",
      menuItem: "",
      department_id: "",
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      dispatch(addPermission({ data: [values] })).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getallPermissions(dispatchparams));
          formik.resetForm();
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  const menuitems = [
    { id: 0, name: "Sidebar" },
    { id: -1, name: "Other" },
  ];

  useEffect(() => {
    dispatch(getAlldepartments());
  }, []);

  useEffect(() => {
    dispatch(getAllUimodules());
  }, []);

  const handledepartment = (e, option) => {
    formik.setFieldValue("department_id", option?.dept_id);
  };
  const handlemodules = (e, option) => {
    formik.setFieldValue("module", option?.module_id);
  };

  return (
    <GlobalDialog
      title={"Add Permission"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"md"}
      closeButton={true}
      popupButton={
        <AddButton size="medium" action={() => setOpen(true)}>
          Add Permission
        </AddButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    name="title"
                    value={formik.values.title}
                    error={formik.touched.title && Boolean(formik.errors.title)}
                    helperText={formik.errors.title}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Title"
                  />
                  <TextField
                    name="description"
                    value={formik.values.description}
                    error={
                      formik.touched.description &&
                      Boolean(formik.errors.description)
                    }
                    helperText={formik.errors.description}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Description"
                  />
                  <TextField
                    name="path"
                    value={formik.values.path}
                    error={formik.touched.path && Boolean(formik.errors.path)}
                    helperText={formik.errors.path}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Path"
                  />
                  <Autocomplete
                    fullWidth
                    name="module"
                    options={uimodules}
                    getOptionLabel={(option) => option.module_name || ""}
                    value={
                      uimodules?.find(
                        (d) => d?.module_id == formik.values.module
                      ) || null
                    }
                    onChange={handlemodules}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="Module"
                        error={
                          formik.touched.module && Boolean(formik.errors.module)
                        }
                        helperText={
                          formik.touched.module && formik.errors.module
                        }
                      />
                    )}
                  />
                  <GlobalSelectField
                    options={{
                      formik,
                      name: "menuItem",
                      label: "Menu item",
                      data: menuitems,
                      keys: {
                        id: "id",
                        value: "name",
                      },
                    }}
                  />
                  <Autocomplete
                    fullWidth
                    name="department_id"
                    options={departments}
                    getOptionLabel={(option) => option.dept_name || ""}
                    value={
                      departments?.find(
                        (d) => d?.dept_id == formik.values.department_id
                      ) || null
                    }
                    onChange={handledepartment}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="Department"
                        error={
                          formik.touched.department_id &&
                          Boolean(formik.errors.department_id)
                        }
                        helperText={
                          formik.touched.department_id &&
                          formik.errors.department_id
                        }
                      />
                    )}
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SaveButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Create"}
                    </SaveButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default AddPermission;
